import React, { FunctionComponent } from 'react';
import { useTheme } from '@rbx/ui';

type TFailedToLoadProps = {
  size: number;
  enableNotificationsM2?: boolean;
};

const FailedToLoad: FunctionComponent<TFailedToLoadProps> = ({ size, enableNotificationsM2 }) => {
  const theme = useTheme();

  if (enableNotificationsM2) {
    return (
      <svg
        width={size}
        height={size}
        viewBox='0 0 62 53'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M28.5365 2.7375C29.5246 1.0875 31.9949 1.0875 32.983 2.7375L59.662 47.2875C60.6501 48.9375 59.415 51 57.4387 51H4.08078C2.10456 51 0.869423 48.9375 1.85753 47.2875L28.5365 2.7375Z'
          stroke={theme.palette.content.standard}
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <circle cx='30.6846' cy='38.8516' r='2.375' fill={theme.palette.content.standard} />
        <path
          d='M30.6846 30.75V19.5'
          stroke={theme.palette.content.standard}
          strokeWidth='3'
          strokeLinecap='round'
        />
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.7'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 42C8 57.44 20.56 70 36 70C40.5891 70 44.9237 68.8905 48.7498 66.9256C51.1395 64.5674 52.9104 61.5717 53.3346 58.6658C54.2226 51.5538 54.2226 44.4458 53.3346 37.3318C52.4966 31.5958 46.4046 25.5038 40.6666 24.6658C37.1106 24.2218 33.5546 23.9998 30.0006 23.9998C26.4446 23.9998 22.8886 24.2218 19.3346 24.6658C16.4289 25.0902 13.4324 26.8619 11.0733 29.2524C9.10912 33.078 8 37.4118 8 42ZM30.0006 64.3638C36.1066 64.3638 45.6546 56.0358 46.7226 55.0858C47.6226 54.2858 47.7026 52.9058 46.9046 52.0058C46.1026 51.1058 44.7246 51.0238 43.8246 51.8238C40.2646 54.9838 33.3626 59.9998 30.0006 59.9998C26.6366 59.9998 19.7366 54.9838 16.1766 51.8238C15.2746 51.0238 13.8986 51.1058 13.0966 52.0058C12.2966 52.9058 12.3766 54.2858 13.2766 55.0858C14.3466 56.0358 23.8926 64.3638 30.0006 64.3638ZM23.4546 41.4538C23.4546 39.6458 21.9886 38.1818 20.1806 38.1818C18.3746 38.1818 16.9106 39.6458 16.9106 41.4538C16.9106 43.2618 18.3746 44.7258 20.1806 44.7258C21.9886 44.7258 23.4546 43.2618 23.4546 41.4538ZM43.0906 41.4538C43.0906 39.6458 41.6246 38.1818 39.8186 38.1818C38.0126 38.1818 36.5446 39.6458 36.5446 41.4538C36.5446 43.2618 38.0126 44.7258 39.8186 44.7258C41.6246 44.7258 43.0906 43.2618 43.0906 41.4538Z'
        fill={theme.palette.content.muted}
      />
      <path
        opacity='0.7'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M74.1684 12.292C76.4464 9.746 79.4864 8 83.8184 8C89.4784 8 93.3164 10.926 93.3164 16.13V16.208C93.3164 21.222 89.8204 23.31 85.4904 24.146L85.0724 26.73H81.1944L80.3224 20.308L80.5124 20.122C85.4904 19.93 87.5044 18.562 87.5044 16.36V16.284C87.5044 14.422 86.0984 13.282 83.7024 13.282C81.4244 13.282 79.4864 14.23 77.6624 16.092L74.1684 12.292ZM86 36.0008H80V30.0008H86V36.0008Z'
        fill={theme.palette.content.muted}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M36 70C20.56 70 8 57.44 8 42C8 26.56 20.56 14 36 14C51.44 14 64 26.56 64 42C64 57.44 51.44 70 36 70ZM62.508 63.266C67.186 57.44 70 50.052 70 42C70 23.222 54.778 8 36 8C17.222 8 2 23.222 2 42C2 60.778 17.222 76 36 76C43.116 76 49.712 73.808 55.172 70.072L71.93 86.828C73.88 88.782 77.046 88.782 79 86.828C80.954 84.874 80.954 81.71 79 79.758L62.508 63.266Z'
        fill={theme.palette.content.muted}
      />
    </svg>
  );
};

export default FailedToLoad;
